<div class="container mt-4">
  <div class="row">
    <div class="col-lg-12">
      <div class="row society-verify-options">
        
        <!-- Card 1 -->
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
          <div class="card box-hover">
            <a href="../../../../assets/society-sample/ActRules/Act_1968.pdf" target="_blank">
              <div class="card-body">
                <div class="text-center">
                  <div class="icon-box icon-box-lg bg-success-light rounded-circle">
                    <i class="fa fa-gavel"></i>
                  </div>
                  <div class="total-projects">
                    <span>H.P. State Co-operative Act, 1968</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- Card 2 -->
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
          <div class="card box-hover">
            <a href="../../../../assets/society-sample/ActRules/Act_2006.pdf" target="_blank">
              <div class="card-body">
                <div class="text-center">
                  <div class="icon-box icon-box-lg bg-primary-light rounded-circle">
                    <i class="fa fa-gavel"></i>
                  </div>
                  <div class="total-projects">
                    <span>H.P. Societies Registration Act, 2006</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- Card 3 -->
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
          <div class="card box-hover">
            <a href="../../../../assets/society-sample/ActRules/Coop_Rule _1971.pdf" target="_blank">
              <div class="card-body">
                <div class="text-center">
                  <div class="icon-box icon-box-lg bg-purple-light rounded-circle">
                    <i class="fa fa-book"></i>
                  </div>
                  <div class="total-projects">
                    <span>H.P. State Cooperative Rules, 1971</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- Card 4 -->
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
          <div class="card box-hover">
            <a href="../../../../assets/society-sample/ActRules/H.P.Societies Registration Rules (english)_2006.pdf" target="_blank">
              <div class="card-body">
                <div class="text-center">
                  <div class="icon-box icon-box-lg bg-purple-light rounded-circle">
                    <i class="fa fa-book"></i>
                  </div>
                  <div class="total-projects">
                    <span>H.P. Societies Registration Rules, 2006</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
